import { oz } from '@weft/utils';
import { UsageByMeterSchema } from './usage-by-meter-schema';

export const GetUsageByMeterResponseSchema = oz.object({
  usageByMeter: oz.array(UsageByMeterSchema),
}).openapi('GetRevenueByCurrencyResponseSchema');

export type GetUsageByMeterResponse = oz.TypeOf<typeof GetUsageByMeterResponseSchema>;